const PREGNANCY_OPTIONS = [
  'Pregnant',
  'Trying to get pregnant',
  'Currently nursing',
  'Taking oral contraceptives'
]

const ALLERGY_OPTIONS = [
  'Aspirin',
  'Acrylic',
  'Erythromycin',
  'Iodine',
  'Latex',
  'Local Anesthetics',
  'Metal',
  'Novocaine',
  'Nitrous Oxide',
  'Penicillin',
  'Sulfa Drugs',
  'Tetracycline',
  'Valium',
  'Xylocaine',
  'Other'
]

const MED_CONDITION_OPTIONS = [
  'Anemia',
  'Chemotherapy',
  'Cold Sores/Fever Blisters',
  'Cortisone Medication',
  'Excessive Bleeding',
  'Frequent Cough',
  'Frequent Headaches',
  'Hay Fever',
  'Hemophilia',
  'High Blood Pressure',
  'Hives or Rash',
  'Kidney Problems',
  'Liver Disease',
  'Parathyroid Disease',
  'Recent Weight Loss',
  'Rheumatism',
  'Shingles',
  'Spina Bifida',
  'Stroke',
  'Thyroid Disease',
  'Venereal Disease',
  'Arthritis or Gout',
  'Blood Disease',
  'Bruise Easily',
  'Congenital Heart Problems',
  'Diabetes',
  'Drug/Alcohol Addiction',
  'Emphysema',
  'Frequent Urination',
  'Heart Murmur',
  'Heart Valve or Pacemaker',
  'Herpes',
  'Hypoglycemia',
  'Lung Disease',
  'Rheumatic Fever',
  'Tuberculosis',
  'Ulcers or GI Problems',
  'Asthma',
  'Chest Pains',
  'Convulsions',
  'Easily Winded',
  'Excessive Thirst',
  'Frequent Diarrhea',
  'Genital Herpes',
  'Heart Attack/Heart Failure',
  'Hepatitis (B or C)',
  'Low Blood Pressure',
  'Irregular Heartbeat',
  'Leukemia',
  'Mitral Valve Prolapse',
  'Radiation Treatments',
  'Renal Disease',
  'Scarlet Fever',
  'Sickle Cell Disease',
  'Stomach/Intestinal Disease',
  'Swelling of Limbs',
  'Tonsillitis',
  'Yellow Jaundice',
  'Artificial Joint',
  'Blood Transfusion',
  'Cancer',
  'Currently Pregnant',
  'Dizziness or Fainting',
  'Eating Disorder',
  'Epilepsy or Seizures',
  'Glaucoma',
  'Heart Trouble',
  'Hepatitis (A)',
  'HIV-AIDS-ARC',
  'Jaw Joint Pain',
  'Psychiatric Care',
  'Sinus Problems',
  'Tumor or Growth',
  'X-ray/Chemotherapy',
  'No to All'
]

const DENTAL_CONDITION_OPTIONS = [
  'Aching or sensitive teeth',
  'Active decay of teeth or gums',
  'Areas of food traps',
  'Bad breath',
  'Broken filling',
  'Broken or missing teeth',
  'Cavities',
  'Clicking or popping jaw',
  'Cold sores',
  'Difficulty opening wide',
  'Dry mouth',
  'Aesthetic concerns with teeth ',
  'Facial surgery',
  'Gag easily',
  'Growths or lesions in your mouth',
  'Gum infection / disease',
  'Gum treatments',
  'Jaw pain or tiredness',
  'Jaw clenching',
  'Loose teeth',
  'Night guard',
  'Oral surgery',
  'Orthodontic treatment',
  'Sensitive or bleeding gums',
  'Swelling or lumps in mouth',
  'Swollen glands',
  'Teeth grinding',
  'Unfavorable dental experience'
]

const REGION_ACRONYMS = {
  // U.S. States
  'Alabama': 'AL',
  'Alaska': 'AK',
  'Arizona': 'AZ',
  'Arkansas': 'AR',
  'California': 'CA',
  'Colorado': 'CO',
  'Connecticut': 'CT',
  'Delaware': 'DE',
  'Florida': 'FL',
  'Georgia': 'GA',
  'Hawaii': 'HI',
  'Idaho': 'ID',
  'Illinois': 'IL',
  'Indiana': 'IN',
  'Iowa': 'IA',
  'Kansas': 'KS',
  'Kentucky': 'KY',
  'Louisiana': 'LA',
  'Maine': 'ME',
  'Maryland': 'MD',
  'Massachusetts': 'MA',
  'Michigan': 'MI',
  'Minnesota': 'MN',
  'Mississippi': 'MS',
  'Missouri': 'MO',
  'Montana': 'MT',
  'Nebraska': 'NE',
  'Nevada': 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  'Ohio': 'OH',
  'Oklahoma': 'OK',
  'Oregon': 'OR',
  'Pennsylvania': 'PA',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  'Tennessee': 'TN',
  'Texas': 'TX',
  'Utah': 'UT',
  'Vermont': 'VT',
  'Virginia': 'VA',
  'Washington': 'WA',
  'West Virginia': 'WV',
  'Wisconsin': 'WI',
  'Wyoming': 'WY',

  // Canadian Provinces
  'Alberta': 'AB',
  'British Columbia': 'BC',
  'Manitoba': 'MB',
  'New Brunswick': 'NB',
  'Newfoundland and Labrador': 'NL',
  'Northwest Territories': 'NT',
  'Nova Scotia': 'NS',
  'Nunavut': 'NU',
  'Ontario': 'ON',
  'Prince Edward Island': 'PE',
  'Quebec': 'QC',
  'Saskatchewan': 'SK',
  'Yukon': 'YT',

  // District of Columbia
  'District of Columbia': 'DC',
};

export default {
  PREGNANCY_OPTIONS,
  ALLERGY_OPTIONS,
  MED_CONDITION_OPTIONS,
  DENTAL_CONDITION_OPTIONS,
  REGION_ACRONYMS
};